<template>
	<div class="main" id="printMe">
	    <div >
			<div class="search" style="background: white;padding:20px;margin-top: 30px;">
				<el-row>
					<el-form  :model="search" label-width="80px">
						<div style="float: left;">
							<el-form-item label="订单号">
								<el-input v-model="search.uuid"  placeholder="请输入订单号"></el-input>
							</el-form-item>
						</div>
						<div style="float: left;">
							<el-form-item label="收货人">
								<el-input v-model="search.link_name"  placeholder="请输入收货人"></el-input>
							</el-form-item>
						</div>
						<div style="float: left;">
							<el-form-item label="订单状态">
								<el-select v-model="search.order_status" placeholder="请选择">
								    <el-option
								      v-for="item in order_status_arr"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
								  </el-select>
							</el-form-item>
						</div>
						<div style="float: left;margin-left: 20px;">
							 <el-button type="primary" @click="SelectSearch">搜索</el-button>
						</div>
					</el-form>
				</el-row>
			</div>
			<div style="height:30px"></div>
			<div style="width: 100%;background: white;padding-top:2.5%">
				<!-- <div style="text-align: left;padding-bottom: 2.5%;padding-left: 2.5%;">
					<el-button size="mini" @click="add()" type="primary" ><i class="el-icon-plus"></i>新增	</el-button>
				</div> -->
				<div class="table">
					<el-table border :data="tableData" row-key="uuid" style="width: 95%;margin-left: 2.5%;" >
						<el-table-column label="订单号" prop="uuid">
						</el-table-column>
						<el-table-column label="微信用户名" prop="user_name">
						</el-table-column>
						<el-table-column label="收货人" prop="link_name">
						</el-table-column>
						<el-table-column label="联系电话" prop="link_mobile">
						</el-table-column>
						<el-table-column label="收货地址" prop="address">
						</el-table-column>
						
						<el-table-column label="下单时间" prop="create_time">
						</el-table-column>
						<el-table-column label="订单状态" prop="order_status_str" align="center">
							<template v-slot="scope">
								<span v-if="scope.row.order_status=='1'" style="color: red;">
									{{scope.row.order_status_str}}
								</span>
								<span v-if="scope.row.order_status=='2'" style="color: green;">
									{{scope.row.order_status_str}}
								</span>
								<el-button size="mini"
								    @click="orderStatusEdit(scope.$index, scope.row)" type="primary"><i class="el-icon-edit"></i>修改状态</el-button>
							</template>
						</el-table-column>
						<el-table-column label="金额" prop="price">
							<template v-slot="scope">
								<span style="color: red;">￥{{scope.row.price}}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" width="300">
						  <template slot-scope="scope">
							<el-button size="mini"
							      @click="print(scope.$index,scope.row)" type="primary"><i class="el-icon-edit"></i>打印</el-button>
							<el-button size="mini"
							    @click="handleEdit(scope.$index, scope.row)" type="primary"><i class="el-icon-edit"></i>订单详情</el-button>
							<el-button size="mini" v-if="scope.row.order_status=='1'"
							  @click="handleDelete(scope.$index, scope.row)" type="danger"><i class="el-icon-edit"></i>取消订单</el-button>
						  </template>
						</el-table-column>
					  </el-table>
				</div>
			</div>
			
			<div class="page" style="padding:30px;text-align: right;background: white;">
				<div class="block">
					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  :page-sizes="[10, 50, 100, 200]"
					  :page-size="search.page"
					  layout="sizes, prev, pager, next"
					  :total="search.total">
					</el-pagination>
				  </div>
			</div>
		</div>
		<edit v-if="edit_show" @close="CloseDialog" :id="id"></edit>
		<print-order v-if="print_show" @close="CloseDialog" :id="id"></print-order>
	</div>
</template>

<script>

import edit from '../components/order/Edit.vue'
import PrintOrder from '../components/order/PrintOrder.vue'
export default{
	name:'Order',
	components:{
		edit,PrintOrder
	},
	data(){
		return {
			search:{
				link_name:"",
				order_id:"",
				page:1,
				limit:10,
			},
			tableData:[],
			edit_show:false,
			print_show:false,
			list_show:true,
			order_status_arr:[],
			id:"",
		}
	},
	methods:{
		print(index,row){
			this.id=row.uuid;
			this.print_show=true;
		},
		orderStatusEdit(index,row){
			let self=this;
			let str="";
			if(row.order_status=='1'){
				str="是否将订单状态改为已完成";
			}else{
				str="当前订单状态为已完成,是否将订单状态改为已下单";
			}
			this.$confirm(str, '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
				var url="/index/Order/SetOrderStatus";
				self.$post(url,{"uuid":row.uuid}).then(function(res){
					if(res.errCode=="1"){
						self.$success(res,self);
						self.SelectSearch()
					}else{
						self.$error(res,self);
					}
				})
			});
		},
		handleEdit(index, row) {
			this.id=row.uuid;
			this.edit_show = !this.edit_show;
		},
		handleDelete(index, row) {
			var self=this;
			this.$confirm('您确定取消该订单吗?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
				var url="/index/Order/Delete";
				self.$post(url,{"id":row.uuid}).then(function(res){
					if(res.errCode=="1"){
						self.$success(res,self);
						self.SelectSearch()
					}else{
						self.$error(res,self);
					}
				})
			});
		},
		file_show(val){
			this.dialogImageUrl = val;
			this.img_show = true;
		},
		handleSizeChange(val){
			this.search.limit=val
			this.SelectSearch()
		},
		handleCurrentChange(val){
			this.search.page=val
			this.SelectSearch()
		},
		async SelectSearch(){
			let res=await this.$get("/index/Order/GetList",this.search)
			this.tableData=res.result.data
			this.search.total=res.result.total
		},
		CloseDialog(){
			this.edit_show=false;
			this.flow_edit_show=false;
			this.print_show=false;
			this.SelectSearch()
		},
		async getCode(){
			let res=await this.$get("/index/Order/GetCode","")
			this.order_status_arr=res.result
		}
	},
	mounted() {
		this.getCode();
		this.SelectSearch()
	}
}
</script>

<style>
</style>
